import { Box, Stack, TextField, Typography } from '@mui/material';
import React, { useCallback, useState } from 'react'
import moment from 'moment';
import CustomSmallSelect from '../custom-input/CustomSmallSelect';
import Iconify from '../iconify';
import { blueGrey } from '@mui/material/colors';

const AnalyticsHeaderV2 = ({
    title,
    period,
    onChange
}) => {

    const onInnerStartChange = useCallback((e) => {
        console.log(e.target.value)
        let _period = {...period}
        _period.start_date = e.target.value
        onChange(_period)
    }, [period])

    const onInnerEndChange = useCallback((e) => {
        console.log(e.target.value)
        let _period = {...period}
        _period.end_date = e.target.value
        onChange(_period)
    }, [period])

    return ( 
        <Box sx={{pb:2}}>
            <Stack direction={'row'} spacing={2} alignItems='center'>
                <Box sx={{
                    flex:1
                }}>
                    <Typography variant='h4'>
                        {title}
                    </Typography>
                </Box>
                
                <Stack direction={'row'} spacing={2} alignItems='center'>
                    <TextField 
                        label="Fecha de inicio"
                        value={period.start_date}
                        type='date'
                        InputProps={{
                            endAdornment:<Iconify icon="solar:calendar-bold" color={blueGrey[400]} />
                        }}
                        onChange={onInnerStartChange}
                    />
                    <TextField 
                        label="Fecha de fin"
                        value={period.end_date}
                        type='date'
                        InputProps={{
                            endAdornment:<Iconify icon="solar:calendar-bold"  color={blueGrey[400]}/>
                        }}
                        onChange={onInnerEndChange}
                    />
                </Stack>
                
            </Stack>
        </Box>
     );
}
 
export default AnalyticsHeaderV2;

const monthsCat = [
  { value: 0, label: "Enero" },
  { value: 1, label: "Febrero" },
  { value: 2, label: "Marzo" },
  { value: 3, label: "Abril" },
  { value: 4, label: "Mayo" },
  { value: 5, label: "Junio" },
  { value: 6, label: "Julio" },
  { value: 7, label: "Agosto" },
  { value: 8, label: "Septiembre" },
  { value: 9, label: "Octubre" },
  { value: 10, label: "Noviembre" },
  { value: 11, label: "Diciembre" }
];

const ongetyearscatalog = () => {
    const year = moment().year()
    let inityear = 2023
    let result = []
    for(let i=inityear; i<=year; i++){
        result.push({
            value:i,
            label:`${i}`
        })
    }
    return result
}
